// extracted by mini-css-extract-plugin
export var cardHeader = "dUiK439gyqNnFo2oR0FW";
export var legHeader = "UwAUtvX3MtsnErblAOJa";
export var legHeaderContentLabel = "i1a_0LKXQ3WGsSc0tqZu";
export var splitSave = "sH5b03DFhsepbTtKfHiA";